<h2 mat-dialog-title class="dialog-header">
  <span class="dialog-title title-large">{{ 'receipts.ui.distintaContanti' | transloco }}</span>

  <button
    mat-icon-button
    mat-dialog-close
    type="button"
    [attr.aria-label]="'receipts.ui.chiudi' | transloco"
    class="close-button"
  >
    <i class="fa-regular fa-xmark"></i>
  </button>
</h2>

<mat-dialog-content class="content">
  <div class="cash-heading">
    <span class="body-medium">{{ 'receipts.ui.incasso' | transloco }}</span>
    <span class="body-medium-emphasized">{{ data.idIncasso }}</span>
  </div>

  @for (riga of righe; track riga.taglio) {
    <div class="cash-row">
      <span class="body-medium">{{ 'receipts.ui.banconoteTaglio' | transloco: { amount: riga.taglio } }}</span>
      <span class="body-medium">{{ 'receipts.ui.qTa3' | transloco: { value0: (riga.quantita) } }}</span>
      <span class="body-medium-emphasized">{{ formatAmount(riga.importo) }}</span>
    </div>
  }

  <div class="cash-row">
    <span class="body-medium">{{ 'receipts.ui.monete' | transloco }}</span>
    <span class="body-medium"></span>
    <span class="body-medium-emphasized">{{ formatAmount(data.totaleMonete) }}</span>
  </div>

  <div class="cash-total">
    <span class="label-medium-emphasized">{{ 'receipts.ui.totale2' | transloco }}</span>
    <span class="label-medium-emphasized">{{ formatAmount(data.totale) }}</span>
  </div>
</mat-dialog-content>
